import { Component, inject } from '@angular/core';
import { LottieComponent, type AnimationOptions } from 'ngx-lottie';

import { LoadingService } from 'app/core/services/loading.service';

@Component({
  selector: 'app-global-loading',
  imports: [LottieComponent],
  styleUrl: './global-loading.scss',
  template: `
    @if (loading.isLoading()) {
      <div class="global-loading" role="status" aria-live="polite" aria-label="Cargando">
        <ng-lottie
          class="global-loading__animation"
          [options]="animationOptions"
          width="140px"
          height="140px"
          aria-hidden="true"
        />
        <span class="visually-hidden">Cargando, espera un momento.</span>
      </div>
    }
  `,
})
export class GlobalLoading {
  protected readonly loading = inject(LoadingService);
  protected readonly animationOptions: AnimationOptions = {
    path: '/assets/splash.json',
    autoplay: true,
    loop: true,
    renderer: 'svg',
  };
}
